import { AppEnvironments } from '@models/app-environments';

export const environment = {
  environment: AppEnvironments.test,
  apiUrl: 'https://test-zbportal-linux.azurewebsites.net',
  proxyApiUrl: 'https://test-api-management-zbportal.azure-api.net',
  assetUrl: 'https://test-cdn.zaner-bloser.com/',
  skofUrl: 'https://test-cdn.zaner-bloser.com',
};
